import React, { Fragment, useMemo } from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import type { RenderModalWrapperProps } from '../../../common/types/commands/index.tsx';
import { getActiveCommandList } from '../../../common/utils/get-active-command-list';
import { useCommandPaletteExpandedCommand } from '../../../controllers/command-palette/index.tsx';

export const ModalWrapper = ({ children }: RenderModalWrapperProps) => {
	const [{ expandedCommand }] = useCommandPaletteExpandedCommand();

	const Wrapper = useMemo(
		() =>
			getActiveCommandList(expandedCommand, expandedCommand?.wasSecondaryTriggered)?.components
				?.Wrapper || Fragment,
		[expandedCommand],
	);

	return (
		<Wrapper>
			<ModalDialogWrapper>{children}</ModalDialogWrapper>
		</Wrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ModalDialogWrapper = styled.div({
	margin: token('space.negative.050', '-4px'),
	borderRadius: '16px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('elevation.surface.overlay', colors.N0),
	boxShadow: token(
		'elevation.shadow.overlay',
		'0px 8px 12px rgba(9, 30, 66, 0.15),0px 0px 1px rgba(9, 30, 66, 0.31)',
	),
});
